exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dlg_header {\r\n    color: #0054a0;\r\n    font-size: 30px;\r\n    line-height: 35px;\r\n    font-weight: bold;\r\n}\r\n\r\n.btn_cancel:hover,\r\n.btn_confirm:hover {\r\n    opacity: 0.8; \r\n    cursor:pointer;\r\n}\r\n\r\n.btn_confirm {\r\n\twhite-space: nowrap;\r\n    background: #1fb001;\r\n    border: 0px;\r\n    color: white;\r\n    padding: 5px 20px;\r\n    /* box-shadow: 3px 3px #9c9799; */\r\n    cursor: pointer;\r\n    min-width: 100px;\r\n}\r\n\r\n.btn_cancel {\r\n\twhite-space: nowrap;\r\n    background: #0054a0;\r\n    border: 0px;\r\n    color: white;\r\n    padding: 5px 20px;\r\n    /* box-shadow: 3px 3px #9c9799; */\r\n    cursor: pointer;\r\n    min-width: 100px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/dialogs/timout-dialog/timout-dialog.component.css
// module id = ../../../../../src/app/components/dialogs/timout-dialog/timout-dialog.component.css
// module chunks = main